import { render } from "./NavigationSectionComponent.vue?vue&type=template&id=70aeaf81&ts=true"
import script from "./NavigationSectionComponent.vue?vue&type=script&lang=ts"
export * from "./NavigationSectionComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__